import React from 'react';

const Footer = () => {

    const currentYear = new Date().getFullYear();

    return (
        <div className='bg-gray-900 py-2'>
            <p className='text-white text-center font-bold'>&copy; Moniruzzaman Sujon - {currentYear}</p>
        </div>
    );
};

export default Footer;
